import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Spinner from "../../../Component/Spinner";
import { AuthContext } from "../../../contexts/AuthProvider";

const AddProduct = () => {
  const { loading } = useContext(AuthContext);
  const { register, handleSubmit, reset } = useForm();

  const handleAddProduct = (data) => {
    const brand = data.brand;
    const model = data.model;
    const sellingPrice = data.sellingPrice;
    const condition = data.condition;
    const Engine = data.Engine;
    const running = data.running;
    const sellerName = data.sellerName;
    const sellerEmail = data.sellerEmail;
    const sellerPhone = data.sellerPhone;
    const sellerLoaction = data.sellerLoaction;
    const img = data.img;

    const addInfo = {
      brand,
      model,
      condition,
      sellingPrice,
      Engine,
      running,
      sellerName,
      sellerEmail,
      sellerPhone,
      sellerLoaction,
      img,
      mode: "pending",
    };

    fetch("https://bike-resell-server-hasanalibd.vercel.app/advertise", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(addInfo),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.acknowledged) {
          toast.success("Product Add Successfully");
        }
      });

    // console.log(addInfo);
  };

  if (loading) {
    return <Spinner></Spinner>;
  }

  return (
    <div className="mt-10 mx-10">
      <h1 className="text-4xl font-bold text-center text-[#149777]">
        Add A Product
      </h1>
      <div className="my-10">
        <form onSubmit={handleSubmit(handleAddProduct)}>
          <div className="grid sm:gap-5 lg:gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Your Name</span>
              </label>
              <input
                type="text"
                placeholder="Hasan Ali"
                {...register("sellerName", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Your Email</span>
              </label>
              <input
                type="email"
                placeholder="hasanali182838@gmail.com"
                {...register("sellerEmail", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Your Phone</span>
              </label>
              <input
                type="number"
                placeholder="01850030472"
                {...register("sellerPhone", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Brand</span>
              </label>
              <select
                {...register("brand", { required: true })}
                className="select input-bordered w-full max-w-xs"
              >
                <option>Hero</option>
                <option>Bajaj</option>
                <option>Suzuki</option>
                <option>Runner</option>
              </select>
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Model</span>
              </label>
              <input
                type="text"
                placeholder="Gixxer"
                {...register("model", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Resale Price</span>
              </label>
              <input
                type="text"
                placeholder="Selling Price"
                {...register("sellingPrice", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Engine</span>
              </label>
              <input
                type="text"
                placeholder="160 cc"
                {...register("Engine", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Running </span>
              </label>
              <input
                type="text"
                placeholder="14500 km"
                {...register("running", { required: true })}
                className="input input-bordered w-full"
              />
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Condition</span>
              </label>
              <select
                {...register("condition", { required: true })}
                className="select input-bordered w-full max-w-xs"
              >
                <option>Fair</option>
                <option>Good</option>
                <option>Excellent</option>
              </select>
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Your Location</span>
              </label>
              <select
                {...register("sellerLoaction", { required: true })}
                className="select input-bordered w-full max-w-xs"
              >
                <option>Dhaka</option>
                <option>Comilla</option>
                <option>Chittagon</option>
                <option>Khulna</option>
                <option>Rongpur</option>
                <option>Others</option>
              </select>
            </div>

            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Product Photo URL</span>
              </label>
              <input
                type="text"
                placeholder="PhotoURL"
                {...register("img", { required: true })}
                className="input input-bordered w-full"
              />
            </div>
          </div>

          <input
            className="btn btn-accent w-full mt-10"
            type="submit"
            value="Add Product"
          />
        </form>
      </div>
    </div>
  );
};

export default AddProduct;
